import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { doPost } from "../../../config/fetchWrapper";
import { urls } from "../../endPoints";


export const PublishTaskAction = createAsyncThunk(
    "publishTask", async (arg, { rejectWithValue }) => {
        try {
            const resposnse = await doPost(urls.publishTask, arg);
            return resposnse;
        } catch (error) {
            return rejectWithValue(error);
        }
    }
)

export const PublishTaskActionSlice = createSlice({
    name: "publishTask",
    initialState: {
        isLoading: false,
        success: false,
        error: null,
        data: false,
    },
    reducers: {
        publishTaskActionReset: () => {
            return {
                isLoading: false,
                success: false,
                error: null,
                data: false,
            }
        }
    },
    extraReducers: {
        [PublishTaskAction.fulfilled]: (state, { payload }) => {
            state.isLoading = false;
            state.success = true;
            state.error = false;
            state.data = payload;

        },
        [PublishTaskAction.pending]: (state) => {
            state.isLoading = true;
            state.success = false;
            state.error = false;
        },
        [PublishTaskAction.rejected]: (state, { payload }) => {
            state.isLoading = false;
            state.success = false;
            state.error = payload;
        },
    }
})

export const { publishTaskActionReset } = PublishTaskActionSlice?.actions;